import { API } from '../API';

export const hasClosedDatePassed = (closeDate) => {
  return new Date(closeDate) < Date.now();
};

export const fetchCampusData = async (jobList) => {
  if (jobList) {
    const campusIds = [];
    for (const job of jobList) {
      job.institution_name = '';
      job.institution_logo = '';
      if (campusIds.indexOf(job.location) === -1) {
        campusIds.push(job.location);
      }
    }

    try {
      const campuses = await API.getMultipleCampusById(campusIds);
      if (campuses.data) {
        const allCampus = {};
        campuses.data.forEach(
          (data) => (allCampus[data._id] = data.suburb.trim() + ", " + data.state)
        );

        for (const job of jobList) {
          job.location = allCampus[job.location];
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
};

export const fetchInstitutionData = async (lazyCollegeData, jobList) => {
  if (jobList) {
    try {
      for (const job of jobList) {
        const lazyData = lazyCollegeData[job.inst_id];
        if (!lazyData) {
          const inst = await API.getInstitutionDataById(job.inst_id);
          if (inst.data) {
            const institution_name = inst.data.institution_name;
            const institution_logo = inst.data.logo;

            lazyCollegeData[job.inst_id] = {
              institution_name,
              institution_logo,
            };
          }
        }
        populateLazyData(lazyCollegeData, job);
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const populateLazyData = (lazyCollegeData, job) => {
  const lazyData = lazyCollegeData[job.inst_id];
  if (lazyData) {
    job.institution_name = lazyData.institution_name;
    job.institution_logo = lazyData.institution_logo;
  }
};

export const getFullDeliveryModeString = (abbr) =>
  abbr === 'online_home'
    ? 'Online; Deliver lesson from home'
    : abbr === 'online_campus'
    ? 'Online; Deliver lesson on-campus'
    : abbr === 'f2f_campus'
    ? 'Face-to-face (in-person); Deliver lesson on-campus'
    : abbr === 'blended'
    ? 'Blended face-to-face/Online; Partly or fully deliver lesson on-campus'
    : abbr === 'online_home_recorded'
    ? `All content pre-recorded by Teacher; no live/synchronous delivery (Work from Home)`
    : abbr === 'online_office_campus_recorded'
    ? `All content pre-recorded by Teacher; no live/synchronous delivery (Work from office location or campus)`
    : '';
